import React from 'react'

const BlogFilter = ({setCatModal,setTimeModal}) => {
  return (
    <div className='BlogFilter'>
      <h2>فیلتر ها :</h2>
      <div className='BlogFilter-box' onClick={()=>setTimeModal(true)}>فیلتر زمان
       <span>( جدید ترین )</span></div>
       <div className='BlogFilter-box cursor-pointer' >فلیتر نمایش
       <span>( محبوب ترین)</span></div>
       <div className='BlogFilter-box cursor-pointer' onClick={()=>setCatModal(true)}>فیلتر دسته بندی 
       <span>(   0 مورد   )</span></div>
    </div>
  )
}

export default BlogFilter